import React from 'react';
import styles from '../flyerList/flyerList.module.scss';
import { friendlyValidity } from '../../helpers/date';
import { getFlyerName } from '../../helpers/flyers';
import { getCityNameFromLocation } from '../../helpers/location';
import useTranslation from 'next-translate/useTranslation';
import cx from 'classnames';
import { Flyer } from '../../definitions/FlyerDefinitions';
import { getFlyerLink } from '../../helpers/links';
import { useRouter } from 'next/router';
import { Locale } from '../../helpers/common';

interface FlyerThumbnailProps {
  flyer: Flyer;
  location: string;
  forceNonePremium: boolean;
}

export default function FlyerThumbnail({ flyer, location, forceNonePremium }: FlyerThumbnailProps): JSX.Element {
  const { t } = useTranslation('application');
  const router = useRouter();
  const locale = router.locale as Locale;

  const city = getCityNameFromLocation(location);
  const imageSrc = flyer.thumbnailPremium && !forceNonePremium ? flyer.thumbnailPremium : flyer.thumbnail;
  return (
    <div className={cx(styles.flippFlyerListingItem, flyer.premium && !forceNonePremium && styles.premium)}>
      <a
        className={cx(
          flyer.premium && !forceNonePremium && styles.premiumFlyerContainer,
          (!flyer.premium || forceNonePremium) && styles.flyerContainer,
        )}
        href={getFlyerLink(flyer, locale, location)}
      >
        <img
          className={cx(styles.flyerThumbnail, styles.cover)}
          alt={t('index_flyers_alt', {
            city,
            flyerName: getFlyerName(flyer),
          })}
          src={imageSrc}
        />
        {flyer.premium && !forceNonePremium && (
          <div className={styles.flyerInfo}>
            <img className={cx(styles.logo, styles.contain)} src={flyer.merchantLogo} />
            <div className={styles.flyerInfoBlock}>
              <p className={styles.flyerName}>{getFlyerName(flyer)}</p>
              <p>{friendlyValidity(t, flyer.validFrom, flyer.validTo)}</p>
            </div>
          </div>
        )}
        {(!flyer.premium || forceNonePremium) && (
          <>
            <p className={styles.flyerName}>{getFlyerName(flyer)}</p>
            <p>{friendlyValidity(t, flyer.validFrom, flyer.validTo)}</p>
          </>
        )}
      </a>
    </div>
  );
}
